<script setup>
import {ref} from 'vue'

const props = defineProps({
    value: String
})

const html = ref('')

// created logic executed during setup initialization
// Strip HTML tags from the editor's content.
html.value = props.value ? String(props.value).replace(/<[^>]+>/gm, '') : ''
</script>

<template>
    <span v-html="html"/>
</template>